import { Box, Container, Divider, Typography } from "@mui/material";

export const PlaceholderText = ({
  title,
  text,
}: {
  title: string;
  text: string;
}) => {
  return (
    <Container sx={{ display: "flex" }}>
      <Box>
        <Typography variant="h5" color="gray">
          {title}
        </Typography>
        <Divider sx={{ my: 3, borderBottomWidth: 2 }} />
        {text.split("\n\n").map((a, i) => {
          return (
            <Box key={i}>
              <Typography sx={{ mb: 2 }} color="gray">
                {a}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Container>
  );
};
